import { render, staticRenderFns } from "./generalOrQuickQuery.vue?vue&type=template&id=54cb1ee5&scoped=true"
import script from "./generalOrQuickQuery.vue?vue&type=script&lang=js"
export * from "./generalOrQuickQuery.vue?vue&type=script&lang=js"
import style0 from "./generalOrQuickQuery.vue?vue&type=style&index=0&id=54cb1ee5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_0a317e13ddfbb0b64829e4e877bda568/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54cb1ee5",
  null
  
)

export default component.exports